import React from 'react';
import Popover from 'components/shared/popover';
import { MASS_ACTION } from 'constants/config';
import ArchiveView from './ArchiveView';
import BulkActionMenu from './BulkActionMenu';
import MassLearnView from './MassLearnView';
import MassOwnershipView from './MassOwnershipView';
import MassTaggingView from './MassTaggingView';

class BulkActionDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeView: null };
    this.setActiveView = this.setActiveView.bind(this);
  }

  setActiveView(activeView) {
    this.setState({ activeView });
  }

  renderActiveView() {
    const sharedProps = { toggleMenu: this.props.toggleMenu };

    switch (this.state.activeView) {
      case MASS_ACTION.MASS_TAGGING:
        return <MassTaggingView />;
      case MASS_ACTION.MASS_OWNERSHIP:
        return <MassOwnershipView />;
      case MASS_ACTION.MASS_LEARN:
        return <MassLearnView />;
      case MASS_ACTION.ARCHIVE:
        return <ArchiveView {...sharedProps} />;
      default:
        return <BulkActionMenu onViewChange={this.setActiveView} />;
    }
  }

  render() {
    return (
      <Popover styleName="BulkAction-dropdown" dismissable={false}>
        {this.renderActiveView()}
      </Popover>
    );
  }
}

export default BulkActionDropdown;
